import React, { useState } from 'react';
import Styled from '../styles/MenuTypePackage.styled';
import { FaHands } from 'react-icons/fa6';
import { IoHeadset } from 'react-icons/io5';
import Cookies from 'js-cookie';

interface MenuTypePackagesProps {
    handleUpdateMenu?: (menu: string) => void;
    hidden?: boolean;
}

const MenuTypePackages: React.FC<MenuTypePackagesProps> = ({ handleUpdateMenu, hidden }) => {
    const [menuActive, setMenuActive] = useState<string | undefined>(() => Cookies.get('menuTypePackage'));


    const handleMenuChange = (menu: string) => {
        const nextMenu = menuActive === menu ? 'none' : menu;
        Cookies.set('menuTypePackage', nextMenu, { expires: 365, path: '/' });
        setMenuActive(nextMenu);
        handleUpdateMenu && handleUpdateMenu(nextMenu);
    };

    return (
        <Styled.Container hidden={hidden}>
            <Styled.Content typeof="button" onClick={() => handleMenuChange('libras')} isSelected={menuActive === 'libras'}>
                <FaHands size={42} />{' '}
                {menuActive === 'libras' ? <span>Você está navegando em libras</span> : <span className="spanContainer">Libras</span>}
            </Styled.Content>
            <Styled.Content typeof="button" onClick={() => handleMenuChange('audio')} isSelected={menuActive === 'audio'}>
                <IoHeadset size={42} />{' '}
                {menuActive === 'audio' ? (
                    <span>Você está navegando em áudio descrição</span>
                ) : (
                    <span className="spanContainer">Audio Descrição</span>
                )}
            </Styled.Content>
        </Styled.Container>
    );
};

export default MenuTypePackages;
